import { z } from 'zod';

export const CreatePromoterFeesSchema = z.object({
  providerBrandId: z.string().uuid('Invalid provider brand ID'),
  promoterBrandId: z.string().uuid('Invalid promoter brand ID'),
  month: z.coerce.date(),
  listingIds: z.array(z.string().uuid('Invalid listing ID')).min(1, 'listingIds cannot be empty'),
  amount: z.number().min(0, 'amount must be a positive number').optional(),
  currency: z.string().length(3, 'currency must be a 3 character ISO code').optional(),
  isReconciled: z.boolean().optional(),
});

export const UpdatePromoterFeesSchema = z
  .object({
    listingIds: z.array(z.string().uuid('Invalid listing ID')).min(1, 'listingIds cannot be empty').optional(),
    amount: z.number().min(0, 'amount must be a positive number').optional(),
    currency: z.string().length(3, 'currency must be a 3 character ISO code').optional(),
    isReconciled: z.boolean().optional(),
  })
  .refine(
    (data) =>
      data.listingIds !== undefined ||
      data.isReconciled !== undefined ||
      data.amount !== undefined ||
      data.currency !== undefined,
    {
      message: 'At least one field must be provided for update',
    },
  );

export type CreatePromoterFeesInput = z.infer<typeof CreatePromoterFeesSchema>;
export type UpdatePromoterFeesInput = z.infer<typeof UpdatePromoterFeesSchema>;
